export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_LOADING = 'SET_LOADING'
